module.exports = __webpack_public_path__ + "img/corrugatedBox16.af0ed767.jpg";